<template>
  <form @submit.prevent="submit">
    <slot></slot>
  </form>
</template>

<script>
export default {
  data () {
    return {
      fields: []
    }
  },
  props: {
    value: Boolean,
    model: {
      type: Object
    },
    rules: {
      type: Object
    }
  },
  provide () {
    return { form: this }
  },
  watch: {
    fields: {
      handler: function (val) {
        let item
        for (let i = 0; i < this.fields.length; i++) {
          item = this.fields[i]
          item.valid = this.rules[item.name].rule.test(this.model[item.name])
          // item.value = val[item.name]
          if (!item.valid) {
            this.$emit('input', false)
            return
          }
        }
        this.$emit('input', true)
      },
      deep: true
    }
  },
  methods: {
    submit () {
      this.$emit('submit')
    },
    setFields () {
      this.fields = []
      let obj
      this.$children.forEach(item => {
        obj = {
          name: item.name,
          _uid: item._uid
        }
        if (item.name) {
          this.fields.push(obj)
        }
      })
    }
  },
  updated () {
    this.setFields()
  },
  mounted () {
    this.setFields()
  }
}
</script>

<style lang="scss" scoped>

</style>
